import React, { useEffect, useState } from "react";
import { useWeb3React } from "@web3-react/core";
import { injected, walletconnect } from "eth/connectors/config";
import ConfirmModal from "./ConfirmModal/ConfirmModal";
import "./WalletUnlock.scss";

type Props = {
  children: any;
};

const connectors = [
  { name: "Browser Wallet", provider: injected },
  { name: "Mobile Wallet", provider: walletconnect },
];

function WalletUnlock({ children }: Props) {
  const [modalOpen, setModalOpen] = useState(false);
  const [activatingConnector, setActivatingConnector] = React.useState<any>();
  const { active, activate, connector } = useWeb3React();

  useEffect(() => {
    if (activatingConnector && activatingConnector === connector) {
      setActivatingConnector(activatingConnector);
      console.log("activating");
      activate(activatingConnector, (err) => console.log(err));
    }
  }, [activatingConnector, connector, activate]);
  if (!active) {
    return (
      <div className="connector-container">
        <h3>Unlock wallet to access</h3>
        <div className="connector-buttons">
          {connectors.map(({ name, provider }) => {
            return (
              <div
                key={`connector-${name}`}
                className="clickable connector-button"
                onClick={() => {
                  setModalOpen(true);
                  setActivatingConnector(provider);
                }}
              >
                Connect {name}
              </div>
            );
          })}
        </div>
        <ConfirmModal modalOpen={modalOpen} setModalOpen={setModalOpen} activatingConnector={activatingConnector} />
      </div>
    );
  } else {
    return children;
  }
}

export default WalletUnlock;
